import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography, makeStyles, } from '@material-ui/core'
import CloseIcon from "@material-ui/icons/Close";
import React from 'react'
import { LanguageContext } from "../../containers/languageprovider";


const useStyles = makeStyles((theme) => ({
    SectionTitle: {
        fontFamily: "Montserrat, Verdana, sans‑serif",
        fontStyle: "normal",
        fontStretch:"normal",
        fontWeight: 500,
        fontSize: "20px",
        lineHeight: "1.25",
        color: "#212121",
        margin: "0 0 18px",
        letterSpacing:"-0.33px",
        maxWidth: "285px",
        maxHeight: "50px",
    },
    DialogContent: {

    },
    TextStyle1: {
        fontWeight: '600',
    },

    submit: {
        maxHeight: "39px",
        maxWidth:"285px",
        fontSize: "14px",
        fontFamily: "Montserrat, Verdana, sans‑serif",
        textTransform: "uppercase",
        padding: '11px 9px 10px',
        borderRadius: '6px',
        backgroundColor: '#1c55e5',
        fontWeight: 600,
        letterSpacing: "0.3px",
    },
    CloseButton:
        { position: "absolute",
            top: "10px", right: "10px",
            cursor: "pointer",
            color: theme.palette.grey[500],
        },
    DialogActions: {
        marginBottom: "1rem",
        padding: "0 2rem",
    },
}));


const SendARequestDialog = ({
                                 openDialog,setOpenDialog,handleClick, setOpenHowItWorksDialog
                             }) => {
    const { dictionary } = React.useContext(LanguageContext);
    const classes = useStyles();
    return (
        <Dialog
            open={openDialog}
            onClose={() => {setOpenDialog(false)}}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{
                style: {
                    position: "relative",
                     maxWidth: "333px",
                    maxHeight:"257px",
                    padding: "23px 24px 26px",
                    borderRadius:"4px",
                    // boxShadow: "0 0 8px 2px #e5e5e5",
                    border: "solid 1px #e5e5e5",
                    backgroundColor: "#fff",
                },
            }}

        >
                <Typography className={classes.SectionTitle}  gutterBottom>
                    {dictionary.SendARequestNotFound}
                </Typography>
                    <div  className={classes.CloseButton} onClick={() => {setOpenDialog(false)}}>
                        <CloseIcon />
                    </div>
                <span
                    id="alert-dialog-description"
                    style={{   maxWidth: '285px',
                        maxHeight: '38px',
                        margin: '0 0 41px 0',
                        fontFamily: 'Barlow, sans-serif',
                        fontSize: '13px',
                        fontWeight: 'normal',
                        fontStretch: 'normal',
                        fontStyle: 'normal',
                        lineHeight: '1.46',
                        letterSpacing: '-0.22px',
                        color: '#212121',}}
                >
                    <span style={{fontWeight: 600}}> {dictionary.SendD4REaRequest} </span><br/>
                    {dictionary.SendARequestBody}
                </span>
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                    onClick={handleClick}
                >
                    {dictionary.SendARequestLink}
                </Button>
            <div style={{width:"100%", display:"flex", justifyContent:"center", marginTop:"2px"}}>
                <a onClick={()=>{setOpenDialog(false)
                    setOpenHowItWorksDialog(true) }}  className={"How-it-works"}>
                    {dictionary.HowItWorks}
                </a>
            </div>
        </Dialog>
    )
}

export default SendARequestDialog